import { useEffect, useState } from 'react';
import { Toast } from 'antd-mobile';
// import * as api from '@/api/modules/seat';
import Api from '@/common/api';
import * as seatUtil from '@/utils/seat';
import {increaseLoading, decreaseLoading, timer} from '@/public';
import { SeatResponse, NewSeat, SrcSysType, SrcWayType, SelectedSeat } from '@/api/modules/seat/interface';

function useGetSeats(union: boolean, sessionInfo: any, currentFloorId = '') {
  /** 原数据 */
  const [dataSource, setDataSource] = useState<SeatResponse|any>({});
  /**左边索引 */
  const [leftIndexs, setLeftIndexs] = useState<any>([]);
  /** 是否多票价 */
  const [isMulPrice, setIsMulPrice] = useState(false);
  // 排序后的价格数组
  const [sortPrices, setSortPrices] = useState([]);
  // 转换后的座位图数据
  const [newData, setNewData] = useState<Array<Array<NewSeat>>>([]);
  const [isEmpty, setIsEmpty] = useState<boolean>(false);
  // 获取标记数据
  const [shadow, setShadow] = useState<any>();
  // 选中的座位
  const [selSeats, setSelSeats] = useState<SelectedSeat[]>([]);
  // 百福得-手机号
  // const [mobile, setMobile] = useState('')
  useEffect(() => {
    const {
      cinemaId = '',
      cinemaName = '',
      dimensional = '',
      hallName = '',
      language = '',
      movieId = '',
      movieName = '',
      showDateTime = '',
      dfScheduleId = '',
      lowPriceTag = false,
      isVendor2Single
    } = sessionInfo;
    if (!cinemaId || !movieId) {
      Toast.info('影院或者影片不存在');
      return;
    }
    // Toast.loading('加载中', 0);
    increaseLoading();
    // req api
    // Api.testDfSeatMap()

    const timeId = setTimeout(() => {
      if(lowPriceTag) {
        Toast.show('网络有点慢，请耐心等待');
      }
    }, 8000);
    setIsEmpty(false);
    Api.getSeatList({
      cinemaId: cinemaId,
      cinemaName: cinemaName,
      dimensional: dimensional,
      hallName: hallName,
      language: language,
      movieId: movieId,
      movieName: movieName,
      showDate: showDateTime,
      srcSys: union ? SrcSysType.BFD : SrcSysType.WWW, // 1-www 2-020 3-400 4-百福德
      srcWay: SrcWayType.H5, //1-PC 2-小程序 3-H5
      dfScheduleId: dfScheduleId, //1-PC 2-小程序 3-H5
      lowPriceTag: lowPriceTag,
      isVendor2Single: isVendor2Single,
      floorId:currentFloorId?currentFloorId:null
    }, lowPriceTag ? 30 * 1000 : null).then((Data: any) => {
      setTimeout(() => decreaseLoading(), 20);
      clearTimeout(timeId);
      if (Data == 'timeout' && lowPriceTag) {
        setIsEmpty(true);
        return;
      }
      if (!Data) {
        return;
      }
      if (!Data.seats || Data.seats.length === 0) {
        setTimeout(() => Toast.info('当前影院无座'), 20);
        return;
      }

      // 保存原始数据
      setDataSource({...Data, newSessionInfo: sessionInfo});
      const seatYValues = Data?.seats.map((item) => item?.seatDesc?.split('排')?.[0]);
      const uniqueSeatY = Array.from(new Set(seatYValues));
      setLeftIndexs(uniqueSeatY);
      const isMul = Data.sectionPrices.length > 1 ? true : false;
      setIsMulPrice(isMul);
      // 转换后的座位图
      let seats: NewSeat[][] = seatUtil.translateOnlineSeatToLocal(
        Data,
        // useRowColumn,
        isMul,
        selSeats
      );
      setSortPrices(seatUtil.getPriceArr(Data.sectionPrices));
      setNewData(seats);
      setShadow(Data?.shadow);
    });
  }, [currentFloorId]);
  return {
    dataSource,
    leftIndexs,
    isMulPrice,
    sortPrices,
    newData,
    isEmpty,
    shadow,
    selSeats,
    setSelSeats
  };
}

export default useGetSeats;

/**
 * 座位状态
 * 0 不显示
 * 1 单 空   多票价 1-*
 * 2 单 选中
 * 3 单 不可选  废弃
 * 4 单 已售
 * 5 双 空   多票价 5-*
 * 6 双 选中
 * 7 双 已售
 */
